module.exports = __webpack_public_path__ + "img/halteknop04.7ea0a25f.png";